import { FormField, SfInputComponent, SfInputFormField } from 'ngx-smart-form';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';
import { EditableFieldComponent } from './editable-field/editable-field.component';

export class EditableField<T = any> extends FormField<T> {
  constructor(field: IFormField<T>) {
    super(field);
  }
  component = EditableFieldComponent;
}
